import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  goldFunds: "goldFunds [Action]",
  goldFundsLoading: "goldFundsLoading [Action]",
  goldFundsAsync: "goldFundsAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const goldFundsReducer = (state = inistiaState, { type, payload }) => {
  switch (type) {
    case actionTypes.goldFunds:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.goldFundsLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.goldFundsLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "GOLD",
    method_type: "gold_funds",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.goldFunds,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.goldFundsLoading,
      payload: false,
    });
  }
}

export function* goldFunds() {
  yield takeLatest(actionTypes.goldFundsAsync, handleWorker);
}
